<div class="main-content">
    <mat-card class="note-card">
    <mat-card-header>
        <mat-card-title>{{rekbotSerial}}: Powód usunięcia notatki</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="text-div">
        {{ note.delete_reason }}
        </div>
        <span>Treść wpisu:</span>
        <div class="text-div">
            {{ note.note }}
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <span>Ilość załączników: {{ note.attachment ? 1 : 0 }}</span>
            <a mat-button target="_blank" [routerLink]="['/rekbot',note.rekbot_id,'notes','show',note.id]">Zobacz więcej</a>
        </div>
        
    </mat-card-content>
    <mat-card-actions class="d-flex">
        <button mat-icon-button class="mat-icon-button" (click)="onCancel()" matTooltip="Anuluj">
            <mat-icon>close</mat-icon>
        </button>
        <div class="d-flex flex-nowrap flex-fill justify-content-end">
            <button mat-icon-button class="mat-icon-button" color="warn" (click)="onConfirmDelete()" matTooltip="Usuń">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
        
    </mat-card-actions>
    </mat-card>    
</div>
